/**
 * CustomColumnHeader - AG Grid custom header component with optional action icon
 */

import React from 'react';
import { Tooltip } from 'antd';
import { IHeaderParams } from 'ag-grid-community';
import { ColumnHeaderAction } from './types';

interface CustomColumnHeaderProps extends IHeaderParams {
  headerAction?: ColumnHeaderAction;
}

const CustomColumnHeader: React.FC<CustomColumnHeaderProps> = (props) => {
  const { displayName, headerAction } = props;

  const handleIconClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    headerAction?.onClick?.();
  };

  const iconElement = headerAction && (
    <span
      className="ag-header-action-icon"
      onClick={handleIconClick}
      style={{
        cursor: 'pointer',
        display: 'inline-flex',
        alignItems: 'center',
        marginLeft: headerAction.position === 'left' ? 0 : 'auto',
        marginRight: headerAction.position === 'left' ? 8 : 0,
        opacity: 0.7,
        transition: 'opacity 0.2s',
      }}
      onMouseEnter={(e) => { (e.currentTarget as HTMLElement).style.opacity = '1'; }}
      onMouseLeave={(e) => { (e.currentTarget as HTMLElement).style.opacity = '0.7'; }}
    >
      {headerAction.tooltip ? (
        <Tooltip title={headerAction.tooltip}>
          {headerAction.icon}
        </Tooltip>
      ) : (
        headerAction.icon
      )}
    </span>
  );

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        padding: '0 4px',
      }}
    >
      {headerAction?.position === 'left' && iconElement}
      <span className="ag-header-cell-text">{displayName}</span>
      {headerAction?.position !== 'left' && iconElement}
    </div>
  );
};

export default CustomColumnHeader;
